import { css } from '@emotion/react';

/**
 * File: commin.css
 * 01) GLOBAL, Loading Background IMG
 * 02)
 */

export const CommonStyled = css`
  /* OVERLAY */
  .dim {
    display: none;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 100;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
  }

  /** 모든 Thumbnail 영역에 적용하는 bgIMG */
  .thumb_loading {
    height: 0px;
    padding-bottom: 140%;
    background-color: #f5f5f5;
    width: 100%;
    background-image: url(/images/common/img_loading.png);
    background-repeat: no-repeat;
    background-position: center;
    background-color: #f2f2f2;
    background-size: 150px;
    image-rendering: -webkit-optimize-contrast;
  }

  @media (min-width: 0) and (max-width: 767px) {
    .thumb_loading {
      background-size: 125px;
      image-rendering: auto;
    }
  }
`;
